'use strict';

module.exports = {
    path: {
        resume: '/public/resume.json'
    },

    navigation: {
        home: 'Home',
        about: 'About',
        // resume: 'Resume',
        work: 'Work',
        education: 'Education',
        skill: 'Skills',
        portfolio: 'Portfolio',
	//videos: 'Videos'
        // testimonials: 'References'
        // contact: 'Contact'
    },

    portfolio: {
        image: {
            'HobbyVR': {
                thumb: 'public/images/hobbyvr.png',
                modal: 'public/images/hobbyvr.png'
            },
            'Shopify Sitemap': {
		thumb: 'public/images/sitemap_logo.jpg',
                modal: 'public/images/sitemap.png'
            },
            'ViralHeat': {
		thumb: 'public/images/viralheat.png',
                modal: 'public/images/viralheat_publishing.png'
            },
            'Cisco WebEx': {
		thumb: 'public/images/webex.png',
                modal: 'public/images/webex.png'
            },
            'BGC Residential': {
		thumb: 'public/images/drupal.png',
                modal: 'public/images/bgc.jpg'
            },
	    'Wordpress': {
		thumb: 'public/images/wordpress.png',
                modal: 'public/images/robbjack.png'
	    },
	    'Jiu Jitsu Federation of Japan': {
		thumb: 'public/images/jjfj.png',
                modal: 'public/images/brackets.png'
	    }
        },
	video: {
	    'HobbyVR': {
		id: 'xAUkGxaLVfE'
	    }
	}
    }
};



// WEBPACK FOOTER //
// ./app/config.js